/**
 * @generated SignedSource<<8c12106acaa62dd9345668d07721e90f>>
 * @relayHash 30d7b582e5b6266eb98098d8a51e480f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a88e85ec57a342835b7d3e5f7bf5f4427023f5a60f6adb3c81918bce4bda25d0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookLogsQuery } from './PlaybookLogsQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookLogsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a88e85ec57a342835b7d3e5f7bf5f4427023f5a60f6adb3c81918bce4bda25d0",
    "metadata": {},
    "name": "PlaybookLogsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
